import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/v1/auth',
  fetchOptions: {
    credentials: 'include',
  },
});
